<template>
    <div class="listview__item ini-listitem"
         :class="['ini-listitem--'+transformToModifierClass(ticketstatus.value)]">
        <div class="listview__content">
            <div class="ini-listitem__header">
                <ini-badge v-if="ticketcategories.value != ''" class="ini-listitem__ticketcategories" name="ticketcategories" :value="ticketcategories.value" pill small>{{ ticketcategories.displayValue }}</ini-badge>
                <span v-if="ticketpriorities.value != ''" class="ini-listitem__ticketpriorities">
                    <TicketPriority :value="ticketpriorities.value"></TicketPriority>
                </span>
                <span class="ini-listitem__createdTime">{{ transformCreateTime }} <span v-if="!ignoreUser">{{this.$t('LBL_BY')}} </span></span>
                <span><strong v-if="!ignoreUser" class="ini-listitem__creator">{{ transformCreator }}</strong></span>
            </div>
            <p class="mt-2">
                <span class="ini-listitem__title" v-html="ticket_title.displayValue"></span>
                <span class="ini-listitem__description" v-html='" - " + description.displayValue'></span>
            </p>
            <div class="ini-listitem__actions">
                <ini-badge class="ini-listitem__ticketstatus" name="ticketstatus" :value="ticketstatus.value" pill>
                    {{ ticketstatus.displayValue }}
                </ini-badge>
                <span class="ini-listitem__ticketcomments" :class="['ini-listitem__ticketcomments--' + transformToModifierClass(ticketstatus.value)]">
                    <span class="icon"/>
                    <span class="text">{{ commentsCount }}</span>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import IniBadge from '@/components/HelpDesk/Badge'
    import StyleMixin from '@/mixins/StyleMixin.js'
    import TicketPriority from "@/components/HelpDesk/TicketPriority"

    export default {
        mixins: [StyleMixin],

        props: {
            ticket_title: {
                type: Object,
                default: ()=> ({value: '', displayValue: ''})
            },
            parent_id: {
                type: Object,
                default: ()=> ({value: '', displayValue: ''})
            },
            description: {
                type: Object,
                default: ()=> ({value: '', displayValue: ''})
            },
            ticketcategories: {
                type: Object,
                default: ()=> ({value: '', displayValue: ''})
            },
            ticketstatus: {
                type: Object,
                default: ()=> ({value: '', displayValue: ''})
            },
            ticketpriorities: {
                type: Object,
                default: ()=> ({value: '', displayValue: ''})
            },
            createdtime: {
                type: Object,
                default: ()=> ({value: '', displayValue: ''})
            },
            contact_id: {
                type: Object,
                default: ()=> ({value: '', displayValue: ''})
            },
            currentUser: String,
            ignoreUser: {
                type: Boolean,
                default: false
            },
            comment_counter: {
                type: Object,
                default: ()=> ({value: 0, displayValue: 0})
            },
        },

        components: {
            IniBadge,
            TicketPriority
        },

        computed: {
            transformCreateTime() {
                let today = moment()
                let createdDate = moment.utc(this.createdtime.value)//new Date(this.createdtime.value + ' UTC')

                //let diff = new DateDiff(today, createdDate)
                let days = today.diff(createdDate, 'days')//Math.floor(diff.days())
                let hours = today.diff(createdDate, 'hours')//Math.floor(diff.hours())
                let minutes = today.diff(createdDate, 'minutes')//Math.floor(diff.minutes())

                if(days >= 1){
                    return this.$t('LBL_HELPDESK_OPEN_DATE_DAYS').replace('$days$', days)
                }
                else if(hours < 1){
                    return this.$t('LBL_HELPDESK_OPEN_DATE_MINUTES').replace('$minutes$', minutes)
                }
                else{
                    if(minutes > 0 && minutes < 60){
                        return this.$t('LBL_HELPDESK_OPEN_DATE_HOURS_MINUTES').replace('$hours$', hours).replace('$minutes$', minutes)
                    }
                    else{
                        return this.$t('LBL_HELPDESK_OPEN_DATE_HOURS').replace('$hours$', hours)
                    }
                }
            },

            transformCreator(){
                if(this.contact_id.value == this.currentUser){
                    return this.$t('LBL_YOU')
                }
                else{
                    if(this.contact_id.displayValue) {
                        return this.contact_id.displayValue
                    } else {
                        return this.$t('LBL_HELPDESK_CREATED_FROM_COMPANY_MEMBER') + this.parent_id.displayValue
                    }
                }
            },

            commentsCount() {
                return this.comment_counter.value ? this.comment_counter.displayValue : 0;
            }
        }
    }
</script><style lang="scss">@import "@/assets/scss/components/HelpDesk/List/_listitem.scss";</style>